import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import forEach from 'lodash.foreach';
import VuexTypes from '@/store/types/index';

import { Auth, defaultState as AuthState } from './modules/Auth/index';
import { Devices, defaultState as DevicesState } from './modules/Devices/index';
import { Users, defaultState as UsersState } from './modules/Users/index';
import { Roles, defaultState as RolesState } from './modules/Roles/index';
import { AuditLogs, defaultState as AuditLogsState } from './modules/AuditLogs/index';
import { Translations, defaultState as TranslationsState } from './modules/Translations/index';
import { Notifications, defaultState as NotificationsState } from './modules/Notifications/index';
import { DepositTypes, defaultState as DepositTypesState } from './modules/DepositTypes/index';

Vue.use(Vuex);

const ResetStateTypes = VuexTypes.resetState;
const moduleStateMap = {
  Auth: AuthState(),
  Devices: DevicesState(),
  Users: UsersState(),
  Roles: RolesState(),
  AuditLogs: AuditLogsState(),
  Translations: TranslationsState(),
  Notifications: NotificationsState(),
  DepositTypes: DepositTypesState(),
};

const store = new Vuex.Store({
  modules: {
    Auth,
    Devices,
    Users,
    Roles,
    AuditLogs,
    Translations,
    Notifications,
    DepositTypes,
  },

  plugins: [new VuexPersistence().plugin],

  actions: {
    [ResetStateTypes.RESET_TO_DEFAULT_STATE]: ({ rootState }, exceptions = []) => {
      let requiredReset = Object.keys(rootState);
      if (exceptions.length) {
        requiredReset = requiredReset.filter((el) => !exceptions.includes(el));
      }
      forEach(requiredReset, (module) => {
        rootState[module] = moduleStateMap[module];
      });
    },
  }
});

export default store;
